import { render } from "./Checkout.vue?vue&type=template&id=e079be84"
const script = {}
script.render = render

export default script